// Shared term dropdown options. 'current' = backend ACTIVE_TERM (.env).
// Add historical terms here as they roll over.
export const TERM_OPTIONS = [
  { value: 'current', label: 'Current Term' },
  { value: '2261', label: 'Spring 2026' },
];
